import React from "react";
import { SharedCard } from "components/Cards/SharedCard";
import { CityScene } from "./index";
import "./city-scene-card.scss";

type CitySceneCardProps = {
  title?: string;
  description?: string;
};

export const CitySceneCard: React.FC<CitySceneCardProps> = ({
  title = "Welcome",
  description = "We are preparing your feed. Very soon you will see here the activity, content and updates in real time.",
}) => {
  return (
    <SharedCard className="citySceneCard">
      <div className="citySceneCard__content">
        <div className="citySceneCard__copy">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>

        <div className="citySceneCard__scene">
          <CityScene />
        </div>
      </div>
    </SharedCard>
  );
};
